var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _ellipse, _ellipse2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_817",
    "data-name": "Group 817",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.301,
    height: 70.301,
    viewBox: "0 0 70.301 70.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 35.15,
    cy: 35.15,
    r: 35.15,
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 34.407,
    cy: 34.407,
    r: 34.407,
    transform: "translate(0.743 0.552)",
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M303.928,664.718c0,12.672-8.268,26.779-18.468,26.779S267,677.391,267,664.718s8.268-19.108,18.468-19.108S303.928,652.049,303.928,664.718Z",
    transform: "translate(-249.745 -626.665)",
    fill: "#fdd835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M280.938,782.375a34.246,34.246,0,0,0,18.914-5.66c-1.268-6.928-6.093-7.325-6.093-7.325h-26.6s-4.55.373-5.975,6.749A34.249,34.249,0,0,0,280.938,782.375Z",
    transform: "translate(-245.69 -712.902)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M98.18,669.74h10.643v8.514a5.32,5.32,0,0,1-5.32,5.32h0a5.32,5.32,0,0,1-5.32-5.32V669.74Z",
    transform: "translate(-68.653 -621.705)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M99.2,668.44h8.611a1.016,1.016,0,0,1,1.016,1.016v7.5a5.32,5.32,0,0,1-5.32,5.32h0a5.32,5.32,0,0,1-5.32-5.32v-7.5A1.016,1.016,0,0,1,99.2,668.44Z",
    transform: "translate(-68.66 -620.799)",
    fill: "#fdb797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M307.53,751.837a15.317,15.317,0,0,0,10.643.03V750.56H307.53Z",
    transform: "translate(-277.982 -699.783)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.633 22.26)",
    fill: "#fdb797"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(18.529 34.201)",
    fill: "#fdb797"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(48.326 34.201)",
    fill: "#fdb797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M280.57,659.892s8.623,11.8,28.4,7.771c0,0,2.208-2.687-3.167-10.937S285.462,649.819,280.57,659.892Z",
    transform: "translate(-259.199 -630.653)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M280.57,659.262s8.623,11.8,28.4,7.771c0,0,2.208-2.687-3.167-10.937S285.462,649.189,280.57,659.262Z",
    transform: "translate(-259.199 -630.214)",
    fill: "#fdd835"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.ee34dbd1011f7e44f7d4702b5c0f182e.svg";
export { ForwardRef as ReactComponent };